const router = function (permissions) {
  return ({
    path: 'fornecedores',
    component: () => import('@/views/Fornecedor/FornecedorModule.vue'),
    meta: { permissions },
    children: [
      {
        path: '/',
        component: () => import('@/views/Fornecedor/FornecedorList.vue'),
        meta: { permissions, title: 'Manutenção de Fornecedores' },
        props: (route) => ({ cnpjs: route.query.cnpjs }),
      },
      {
        path: 'cadastrar',
        component: () => import('@/views/Fornecedor/FornecedorProfile.vue'),
        meta: { permissions, title: 'Cadastrando Fornecedor' },
      },
      {
        path: 'alterar',
        component: () => import('@/views/Fornecedor/FornecedorProfile.vue'),
        meta: { permissions, title: 'Editando Fornecedor' },
      },
    ],
  })
}

export default {
  router,
}
